import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-644d4f1e")

_pushScopeId("data-v-644d4f1e")
const _hoisted_1 = {
  id: "myChart",
  ref: "canvasElem"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("canvas", _hoisted_1, null, 512))
})